import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";

// valueFormatter that mirrors TradeRootStringCellRenderer for copy/paste —
// reads the field name from the colDef's cellRendererParams so the formatter
// can be shared across every column that uses the renderer.
export function tradeRootStringValueFormatter(params: any): string {
  const fieldName: string | undefined =
    params.colDef?.cellRendererParams?.fieldName;
  if (!fieldName) return "";
  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const value = (fullTradeData as any)?.[fieldName];
  return value != null ? String(value) : "";
}
